import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import * as visitorIdActions from '../../redux/modules/visitorId';
import App from './App';

export default withRouter(connect(null, {
  loadVisitorId: visitorIdActions.loadVistorIdIfNeeded,
})(App));
